import { createSlice } from "@reduxjs/toolkit";
import { advertisingAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const advertisingSlice = createSlice({
  name: "advertising",
  initialState: data,
  reducers: {
    advertisingSlice(state) {
      state.isLoading = false;
    },
    advertisingSliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    advertisingSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    advertisingSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const advertisingHandler = () => async (dispatch: any) => {
  try {
    dispatch(advertisingAction.advertisingSlice());
    const response: any = await advertisingAPI();
    dispatch(advertisingAction.advertisingSliceSuccess(response));
  } catch (e: any) {
    dispatch(advertisingAction.advertisingSliceFailure(e?.response?.data?.message));
    dispatch(advertisingAction.advertisingSliceReset());
  }
};
export default advertisingSlice.reducer;
export const advertisingAction = advertisingSlice.actions;
